"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deselectSectionUtls_1 = require("../Common/deselectSectionUtls");
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var PreviewAccept_1 = __importDefault(require("./Controls/PreviewAccept/PreviewAccept"));
var ButtonMenu_1 = require("./Controls/ButtonMenu/ButtonMenu");
var AcceptPreviewEventEmitter_1 = require("./Controls/AcceptPreviewEventEmitter");
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
var react_1 = __importDefault(require("react"));
var ReactAcceptFlow_1 = require("./ReactAcceptFlow");
var axios_1 = __importDefault(require("axios"));
var AcceptBlock = (function () {
    function AcceptBlock(project, block, make, modal, createUi, Editor, viewState, usingFeature, attachQuoteAcceptToolbar, brandStore, telemetry, acceptTelemetry, blockStore, stylePermissionStore, projectStore, acceptPreviewEventEmitter, di, $timeout, QwilrStripe, account, apiBaseUrl) {
        var _this = this;
        var mainContent = make(Editor, {
            model: block.contentAreas.main,
            options: {},
            configuration: "standard",
        });
        var closeInlineForm = function () {
            _this.ui.showInlineForm = false;
        };
        var previewAccept = make(PreviewAccept_1.default, {
            accepters: block.settings.accepters,
            closeInlineForm: closeInlineForm,
        });
        var showInlinePreview = function () {
            telemetry.track("Accept Flow Previewed");
            _this.ui.showInlineToolbar = false;
            _this.ui.showInlineForm = true;
            _this.ui.inlineFormUi = previewAccept.preview();
        };
        acceptPreviewEventEmitter.addListener(AcceptPreviewEventEmitter_1.AcceptPreviewEvent.OpenPreview, showInlinePreview);
        acceptPreviewEventEmitter.addListener(AcceptPreviewEventEmitter_1.AcceptPreviewEvent.ClosePreview, closeInlineForm);
        var usingEsign = !usingFeature(FeatureFlag_1.default.OptOutNewEditor);
        var inlineToolbarOptions = [
            {
                value: "preview",
                hint: "Preview how your clients will sign and pay after clicking accept",
                hintSize: "large",
                onClick: function () {
                    telemetry.track("Accept Button Previewed", {}, {
                        blockIntercom: true,
                    });
                    if (usingFeature(FeatureFlag_1.default.PreviewAccept) && !usingEsign && project.previewAcceptanceData != null) {
                        return modal
                            .showConfirmModal({
                            title: "Overwrite Accept Data",
                            explainer: "Continuing will overwrite previous preview accept data",
                            confirmLabel: "Continue",
                            cancelLabel: "Cancel",
                        })
                            .then(function (isConfirmed) {
                            if (isConfirmed) {
                                return previewAccept.preview();
                            }
                        });
                    }
                    else {
                        if (usingEsign) {
                            showInlinePreview();
                        }
                        else {
                            return previewAccept.preview();
                        }
                    }
                },
                icon: "preview",
            },
        ];
        var inlineToolbar = make(attachQuoteAcceptToolbar, {
            options: inlineToolbarOptions,
            block: block,
            brandStore: brandStore,
            blockStore: blockStore,
            stylePermissionStore: stylePermissionStore,
        });
        this.ui = createUi(require("./Accept.html"), {
            block: block,
            viewState: viewState,
            mainContent: mainContent.ui,
            getAlignment: function () {
                return block.style != null ? block.style.acceptButton.alignment : undefined;
            },
            inlineToolbarUi: inlineToolbar.ui,
            showInlineToolbar: projectStore.isEditable && false,
            inlineFormUi: null,
            showInlineForm: false,
            showPreview: usingEsign ? showInlinePreview : null,
            useReactAcceptFlow: usingFeature(FeatureFlag_1.default.AcceptFormReact),
            acceptFlow: null,
            $init: function ($scope) {
                _this.ui.acceptFlow = (0, MountReactComponent_1.default)(createUi, di)(react_1.default.createElement(ReactAcceptFlow_1.ReactAcceptFlowContainer, {
                    onClose: function () {
                        $timeout(closeInlineForm);
                    },
                    onSubmitForm: function (acceptData, isSpringboardUser) { return __awaiter(_this, void 0, void 0, function () {
                        var err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    acceptData.linkSecret = project.links[0].secret;
                                    acceptData.visitToken = "mocktoken";
                                    acceptData.sessionStartedAt = Math.round(Date.now() / 1000);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4, axios_1.default.post("".concat(apiBaseUrl, "/projects/").concat(project._id, "/preview-accept"), acceptData, {
                                            withCredentials: true,
                                        })];
                                case 2:
                                    _a.sent();
                                    return [3, 4];
                                case 3:
                                    err_1 = _a.sent();
                                    throw err_1;
                                case 4: return [2];
                            }
                        });
                    }); },
                    settings: block.settings,
                    $scope: $scope,
                    $timeout: $timeout,
                    isPreviewAccept: true,
                    account: account,
                    stripePublicKey: QwilrStripe,
                    projectId: project._id,
                    optOutSpringboard: usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu),
                    telemetry: telemetry,
                }));
            },
            menuButton: function () {
                return make.invoke(ButtonMenu_1.mountButtonMenu, null, {
                    getAcceptLabel: function () { return block.settings.button.customLabel; },
                    setAcceptLabel: function (newLabel) { return (block.settings.button.customLabel = newLabel); },
                });
            },
            hasEditAccess: projectStore.isEditable,
            deselectInlineToolbar: function (e) {
                if ((0, deselectSectionUtls_1.hasDeselectElementClicked)(e.target)) {
                    return (this.showInlineToolbar = false);
                }
            },
            onAcceptButtonChange: function (newLabel) {
                return (block.settings.button.customLabel = newLabel);
            },
            handleAcceptButtonClick: function ($event) {
                if (!usingEsign) {
                    $event.stopPropagation();
                    if (projectStore.isEditable && (0, FeatureFlag_1.isUsingTCDC)(usingFeature)) {
                        return (this.showInlineToolbar = !this.showInlineToolbar);
                    }
                    else {
                        return previewAccept.preview();
                    }
                }
            },
        });
    }
    return AcceptBlock;
}());
exports.default = AcceptBlock;
